export const VOICE_WAVEFORM = [6, 12, 9, 16, 10, 18, 8, 14, 11, 17, 9, 15, 10, 13] as const;
